export const environment = {
  production: false,
  allowUnauthenticatedTestAccess: false,
  backendApiEndpoint: 'https://dev-api-bedrijfsrestaurant.azurewebsites.net/api/',
  backendApiScope: 'api://8f14dc68-a705-4b71-8a09-217c29f16317/access_as_user',
  authClientId: '8f14dc68-a705-4b71-8a09-217c29f16317',
  authTenantId: 'ff433bba-0f7c-49c7-90e6-1a3ab2df1e48',
  oneSignalAppId: 'ce442be8-20d5-4bce-8d53-4cac169a7cee',
};
